// Urteil über die Zugangs-Abfrage (`has_app_access`).
//
// Warum das eine eigene Funktion mit drei Ausgängen ist: der Unterschied
// zwischen „der Server sagt nein" und „wir haben gar keine Antwort bekommen"
// hat im Callcenter echten Schaden angerichtet. Vorher galt
//
//     const hasAccess = accessRes.data === true;
//     if (!hasAccess) { await supabase.auth.signOut(); … }
//
// — geprüft wurde also nur `data`, nie `error`. Lief die Abfrage in einen
// Fehler oder ins Zeitlimit (Mobilfunk-Aussetzer, und genau davon kamen die
// Zugriffe), war `data` leer, der Code las daraus „kein Zugriff" und meldete
// die Person still ab. Die Oberfläche schickte sie auf den Login und danach
// aufs Dashboard. Mitten im Buchen sah das aus wie „die Seite lädt sich
// einfach neu", und alle eingestellten Filter waren weg
// (Callcenter-Feedback 17.08.2026, siehe docs/befund-buchungsseite-2026-08-17.md).
//
// Regel ab jetzt: abgemeldet wird nur bei einem ausdrücklichen Nein.
// Keine Antwort heißt weitermachen — die nächste Prüfung kommt ohnehin.
export type Zugangsurteil = 'zugelassen' | 'verweigert' | 'keine-antwort';

export function zugangsurteil(res: { data: unknown; error: unknown }): Zugangsurteil {
  if (res.error) return 'keine-antwort';
  if (res.data === true) return 'zugelassen';
  if (res.data === false) return 'verweigert';
  // Weder true/false noch ein Fehler (z. B. null, weil die Antwort unterwegs
  // abgeschnitten wurde): kein verlässliches Nein, also nicht abmelden.
  return 'keine-antwort';
}
